import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import cookies from '../../utils/cookies'

const ProtectedRoute = ({ children, ...rest }) => {
  const user = (() => {
    try {
      const u = cookies.get('user')
      return JSON.parse(u)
    } catch {
      return null
    }
  })()
  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

export default ProtectedRoute
